export type WatchlistState = 'unwatchlisted' | 'watchlisted' | 'price_alert_set'

export const calcWatchlistState = (
  is_watchlisted: boolean,
  is_price_alert: boolean,
): WatchlistState => {
  if (!is_watchlisted && !is_price_alert) {
    return 'unwatchlisted'
  } else if (is_watchlisted && !is_price_alert) return 'watchlisted'
  else if (is_watchlisted && is_price_alert) return 'price_alert_set'
  else return 'unwatchlisted'
}
